/* EmailComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./EmailRenderer");
const EmailRegex = new RegExp(
    /^(.*\s<(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))>)|((([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,})))$/
);

class EmailComponent extends EventEmitter {
    constructor(logger, uemail) {
        super();
        this._logger = logger;
        this._titleText = "Recipient email";
        this._message = "Please specify recipient's email address and report format.";
        this._placeHolderTitle = "Enter recipient email";
        this._userEmail = uemail;
        this.reportFormat = "csv";
        this._renderer = new Renderer(this);
        this._registerListeners();
        this._renderer.render();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {}
    _unregisterListeners() {}
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }
    get titleText() {
        return this._titleText;
    }
    get logger() {
        return this._logger;
    }
    get message() {
        return this._message;
    }
    get isMessageProvided() {
        return this.message ? true : false;
    }
    get placeHolderTitle() {
        return this._placeHolderTitle;
    }
    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(
            () => {
                this._logger = undefined;
                this._renderer = undefined;
                this._titleText = undefined;
                this._message = undefined;
                this._placeHolderTitle = undefined;
                this._context = undefined;
                this.reportFormat = undefined;
            },
            (err) => {
                this._logger.warn({ error: err }, "EmailComponent.shutdown() error");
            }
        );
    }
    createAction(name) {
        this._context.resolve({ name, type: this.reportFormat });
    }
    cancelAction() {
        this._context.reject({ userRejected: true });
    }
    // prettier-ignore
    set "$teve.ui.context"(context) { //jshint ignore:line
        this._context = context;
    }

    isValidEmail(email) {
        return EmailRegex.test(email);
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = EmailComponent;
